import React from 'react';

import type {FileInfo} from '../fileInfoFromName';
import {PatchViewer} from '../PatchViewer/PatchViewer';
import type {FileBrowserFile} from '../types';
import {CodePreview} from './CodePreview';

type PatchPreviewProps = {
  artifactId: string | null;
  file: FileBrowserFile;
  fileInfo: FileInfo;
  fileBody: string | undefined;
};
export function PatchPreview({
  artifactId,
  file,
  fileInfo,
  fileBody,
}: PatchPreviewProps) {
  if (artifactId && fileBody) {
    // In the case that the file is a diff, we want to use the patch viewer
    // instead of the code preview. The patch viewer will attempt to parse the
    // diff and display it in a more user-friendly way.
    //
    // But to show the nicer patch, it needs an artifact to read from.
    return (
      <PatchViewer artifactId={artifactId} file={file} fileBody={fileBody} />
    );
  } else {
    return <CodePreview file={file} fileInfo={fileInfo} fileBody={fileBody} />;
  }
}
